import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexSupport',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const SupportTicket = defineAsyncComponent(() => import("@/components/theme/support/SupportTicket.vue"))
const SupportTable = defineAsyncComponent(() => import("@/components/theme/support/SupportTable.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Apps",
      mains: "Support Ticket",
      title: "Support Ticket"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), {
          colClass: "col-sm-12 ",
          title: "Support Ticket List ",
          cardhaderClass: "card-no-border pb-0",
          headerTitle: "true",
          text: "true",
          desc: "List of ticket Opened by customers"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SupportTicket)),
            _createVNode(_unref(SupportTable))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})